import { useEffect } from 'react';
import { Form, Modal, Upload } from 'antd';
import { useGetChildDocumentTypesQuery } from '@/services/general-api';
import { useUploadChildDocumentMutation } from '@/services/child-api';
import { UploadSvg } from '@/assets/icons';
import Select from '@/components/select';
import Button from '@/components/button';

const UploadModal = ({ childId, open, refetch, onClose }) => {
  const { data: typeData, isLoading: loadingTypeData } = useGetChildDocumentTypesQuery();
  const [uploadDocument, { isLoading: uploading }] = useUploadChildDocumentMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [open, form]);

  const onFinish = async (values) => {
    const body = new FormData();
    body.append('file', values.document);

    let type;
    if (values.typeCode === "tp") {
      type = "transition-plan";
    } else if (values.typeCode === "rtrf") {
      type = "return-to-recruitment-form"
    } else {
      type = values.typeCode.slice(3);
    }
    try {
      await uploadDocument({ childId, type, body }).unwrap();
      refetch();
      onClose();
    } catch (err) {
      console.log('err :>> ', err);
    }
  };

  return (
    <Modal
      title="Upload Document"
      open={open}
      okText="Upload"
      confirmLoading={uploading}
      onOk={() => form.submit()}
      onCancel={onClose}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item name="typeCode" label="Type" rules={[{ required: true }]}>
          <Select options={typeData} loading={loadingTypeData} valueName="code" />
        </Form.Item>
        <Form.Item
          name="document"
          label="Document"
          valuePropName="file"
          getValueFromEvent={(e) => e?.file}
          rules={[{ required: true, message: 'Please select document' }]}
        >
          <Upload beforeUpload={() => false} maxCount={1} showUploadList={{ showRemoveIcon: false }}>
            <Button icon={<UploadSvg />}>Select document file</Button>
          </Upload>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UploadModal;
